import * as React from 'react';
import { IListItem } from '@nkr/models/index';
import { Col, Checkbox, FormControl, ListGroupItem, Row } from 'react-bootstrap';
import { ThemeProvider } from 'styled-components';

interface IProps {
    
    orderTypeId: number,
    testTypes: IListItem[],
    months1: boolean,
    months3: boolean,
    months6: boolean,
    months12: boolean,
    months18: boolean,
    months24: boolean,

    recpMrn: string,
    recpFirstName: string,
    recpLastName: string,
    recpGender: string,
    recpDob: string,
    recpRecentTransplantDate: string,

    recpAddress: string,
    recpCity: string,
    recpState: string,
    recpPostalCode: string,
    recpMedicareNumber: string,

    physFirstName: string,
    physLastName: string,
    physAddress: string,
    physCity: string,
    physState: string,
    physPostalCode: string,
    physNpi: string
}

class EnrollmentConfirmation extends React.Component<IProps> {
    componentDidMount() {
    }

    render = () => {
        return (
                <Row>
                    <div className='col-sm-12'>
                        <h4>Enrollment Information</h4>
                        <Row>
                            <Col sm={7}>
                                Test Type: {this.props.testTypes.find(x => parseInt(x.value) == this.props.orderTypeId).description}
                            </Col>

                            <Col sm={5}>
                                Selected Months: 
                                <Checkbox  name='months1' checked={this.props.months1} disabled={true} inline>1 mo</Checkbox>
                                <Checkbox  name='months3' checked={this.props.months3} disabled={true} inline>3 mo</Checkbox>{' '}
                                <Checkbox  name='months6' checked={this.props.months6} disabled={true} inline>6 mo</Checkbox>{' '}
                                <Checkbox  name='months12' checked={this.props.months12} disabled={true} inline>12 mo</Checkbox>{' '}
                                <Checkbox  name='months18' checked={this.props.months18} disabled={true} inline>18 mo</Checkbox>{' '}
                                <Checkbox  name='months24' checked={this.props.months24} disabled={true} inline>24 mo</Checkbox>{' '}
                            </Col>
                        </Row>
                        <hr/>

                        <h4>Recipient Information</h4>
                        <Row>
                            <Col sm={4}>
                                First Name: {this.props.recpFirstName}
                            </Col>

                            <Col sm={4}>
                                Last Name: {this.props.recpLastName}
                            </Col>

                            <Col sm={4}>
                                MRN #: {this.props.recpMrn}
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={4}>
                                Gender: {this.props.recpGender}
                            </Col>

                            <Col sm={4}>
                                Date of Birth: {this.props.recpDob}
                            </Col>

                            <Col sm={4}>
                                Recent Transplant Date: {this.props.recpRecentTransplantDate}
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                Medicare Number: {this.props.recpMedicareNumber}
                            </Col>
                        </Row>

                        <hr />

                        <h4>Recipient Address Information</h4>
                        <Row>
                            <Col sm={12}>
                                Address: {this.props.recpAddress}
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={4}>
                                City: {this.props.recpCity}
                            </Col>

                            <Col sm={4}>
                                State: {this.props.recpState}
                            </Col>

                            <Col sm={4}>
                                Postal Code: {this.props.recpPostalCode}
                            </Col>
                        </Row>

                        <hr />
                        <h4>Ordering Physician Information</h4>
                        <Row>
                            <Col sm={6}>
                                First Name: {this.props.physFirstName}
                            </Col>

                            <Col sm={6}>
                                Last Name: {this.props.physLastName}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                Address: {this.props.physAddress}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                City: {this.props.physCity}
                            </Col>

                            <Col sm={4}>
                                State: {this.props.physState}
                            </Col>

                            <Col sm={4}>
                                Postal Code: {this.props.physPostalCode}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                NPI #: {this.props.physNpi}
                            </Col>
                        </Row>                    
                    </div>
                </Row>
        )
    }
}

export default EnrollmentConfirmation;